import IFrame from '../../../components/IFrame/IFrame';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { currentUser } from '../../../store';
import Box from '@mui/material/Box';

const IFramePage = () => {
  let { moduleId } = useParams();
  const user = useRecoilValue(currentUser);

  let iframeSrc;
  Object.keys(user?.orgSettings ?? []).forEach((key) => {
    if (user.orgSettings[key].scoped_entity_id === moduleId) {
      iframeSrc = user.orgSettings[key].setting_value;
    }
  });

  return (
    <Box sx={{ height: '100%' }}>
      <IFrame name="Report" src={iframeSrc ?? 'https://growthsayer.cloud.looker.com/login/embed/%2Fembed%2Fdashboards%2F1%3FLocation%3Dcatalyst405?permissions=%5B%22access_data%22%2C%22see_lookml_dashboards%22%2C%22see_looks%22%2C%22see_user_dashboards%22%5D&models=%5B%22growthsayer_eval%22%5D&signature=Pj7VWyickjeNUsiy%2F3LRL8Mv8NM%3D&nonce=%22c0e9bd7029311d012b19ad4d92b5800d%22&time=1701985688&session_length=2592000&external_user_id=%2259867iuy%22&access_filters=%7B%7D&first_name=%22Tal%22&last_name=%22Cohen%22&user_attributes=%7B%7D&force_logout_login=true'} />
    </Box>
  )
}

export default IFramePage
